// ----------------------------------------------------------------------------
// Component: Accordion
// ----------------------------------------------------------------------------
//
// Generic accordion component.
//
// Requires the following structure:
// .js-accordion__item
//     .js-accordion__button
//     .js-accordion__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './accordion.scss';


// -------------------------------------
// Variables
// -------------------------------------

const ACCORDION            = '.js-accordion';
const ACCORDION_BUTTON     = '.js-accordion__button';
const ACCORDION_ITEM       = '.js-accordion__item';
const ACCORDION_CONTENT    = '.js-accordion__content';
const ACCORDION_TITLE      = '.accordion__title';

// Constant trigger classes
const OPEN_CLASS          = 'is-open';



// -------------------------------------
// Helper Functions
// -------------------------------------

function toggleAccordion(accordion) {
    accordion.item.parentElement.querySelectorAll('.' + OPEN_CLASS).forEach(function(e) {
        e.classList.remove(OPEN_CLASS);
    });

    accordion.item.parentElement.querySelectorAll(ACCORDION_CONTENT).forEach(function(e) {
        e.style.overflow = 'hidden';
        e.setAttribute('hidden', true);
    });

    accordion.item.parentElement.querySelectorAll(ACCORDION_BUTTON).forEach(function(e) {
        e.setAttribute('aria-expanded', 'false');
    });

    accordion.item.parentElement.querySelectorAll(ACCORDION_CONTENT + " a").forEach(function(e) {
        e.setAttribute('tabindex', -1);
    });

    if (accordion.isOpening) {
        accordion.button.classList.add(OPEN_CLASS);
        accordion.item.classList.add(OPEN_CLASS);
        accordion.content.classList.add(OPEN_CLASS);

        accordion.button.setAttribute('aria-expanded', 'true');
        accordion.content.setAttribute('hidden', false);
        accordion.content.querySelectorAll('a').forEach(function(el) {
            el.setAttribute('tabindex', null);
        });

        // This allows select boxes to flow out after it's opened
        setTimeout(function() {
            accordion.content.style.overflow = 'visible';
        }, 200);
    }
}

function accordionEventHandle(e) {
    // Store elements as an object
    const accordion = {
        button:    e.target,
        item:      e.target.closest(ACCORDION_ITEM),
        title:     e.target.closest(ACCORDION_TITLE),
        content:   e.target.closest(ACCORDION_TITLE).nextElementSibling,
        isOpening:  !e.target.classList.contains(OPEN_CLASS),
        container: e.target.closest(ACCORDION),
        button_group: e.target.closest(ACCORDION).querySelectorAll(ACCORDION_BUTTON)
    };

    // Collapse any open sibling & children accordions if data attribute set to true
    if (e.type === 'click') {
        e.preventDefault();
        toggleAccordion(accordion);
    } else if (e.type === 'keydown') {
        const key = e.which.toString();
        if (key.match(/35|36|38|40/)) {
            e.preventDefault();
            const index = Array.prototype.indexOf.call(accordion.button_group, e.target);
            const length = accordion.button_group.length;
            let newIndex;
            switch(key) {
                case '38': // Up
                    newIndex = (index + length + -1) % length;
                    accordion.button_group[newIndex].focus();
                    break;
                case '40': // Down
                    newIndex = (index + length + 1) % length;
                    accordion.button_group[newIndex].focus();
                    break;
                case '35': // End
                    accordion.button_group[length - 1].focus();
                    break;
                case '36': // Home
                    accordion.button_group[0].focus();
                    break;
            }
        }
    }
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const accordionContentLinks = document.querySelectorAll(ACCORDION_CONTENT + ' a');
    const accordionButtons = document.querySelectorAll(ACCORDION_BUTTON);

    accordionContentLinks.forEach(function(e) {
        e.setAttribute('tabindex', -1);
    });

    accordionButtons.forEach(function(e) {
        e.addEventListener('click', accordionEventHandle);
        e.addEventListener('keydown', accordionEventHandle);
    });
});
